export default __webpack_public_path__ + "static/media/circle.0a4ed849.svg";